'use client'

import { useCustomImageContext } from "@/contexts/CustomImageContext"
import { useProductDetailPageContext } from "@/contexts/ProductDetailPageContext"
import { Brush } from "lucide-react"

export const CustomizeButton = () => {
    const [__, setProductPageCtx] = useProductDetailPageContext()
    const [customImgCtx, _] = useCustomImageContext()

    const openModal = () => {
        setProductPageCtx(prev => ({ ...prev, customizeModalOpen: true }))
    }

    if (customImgCtx.frontImages.length + customImgCtx.backImages.length == 0)
        return <></>

    return (
        <div className="flex md:hidden items-center bg-black p-0.5 rounded-full rainbow-input shadow-lg">
            <button
                className="flex items-center justify-center h-full rounded-full bg-white px-3 py-1 text-sm font-extralight"
                id="customize-button-nav"
                onClick={openModal}
            >
                <Brush className="size-5 me-1" /> Customize
            </button>
        </div>
    )
}